import front_view from "../assets/images/001_temple_front_view.jpeg";
import night_view from "../assets/images/002_temple_night_view.jpeg";
import side_view from "../assets/images/003_temple_side_view.jpeg";
//import footfall from "../assets/images/004_footfall.jpg";
import procession from "../assets/images/005_RK_Procession.jpg";
import cost_breakup from "../assets/images/006_cost_breakup.png";
import wall_of_gratitude from "../assets/images/Crowdfund_WALL.png";
import update1 from "../assets/images/update1.jpeg"
import update2 from "../assets/images/update2.jpeg"
import update3 from "../assets/images/update3.jpeg"
import update4 from "../assets/images/update4.jpeg"
import update5 from "../assets/images/update5.jpeg"
import update6 from "../assets/images/update6.jpeg"
import impact_img from "../assets/images/009_impact.png";
import image9 from "../assets/images/image9.jpg";
import image10 from "../assets/images/image10.jpg";
import image12 from "../assets/images/image12.jpg";
import image13 from "../assets/images/image13.jpg";
import image14 from "../assets/images/Crowdfund_WALL.png";
import image15 from "../assets/images/logo.png";
import image16 from "../assets/images/logo.jpeg";
import image17 from "../assets/images/image17.jpg";
import image18 from "../assets/images/image18.jpg";
import image19 from "../assets/images/image19.png";

// import 001_temple_front_view from "../assets/images/001_temple_front_view.jpg";

export const campaign = {
  front_view,
  context:
    "Join me in supporting the creation of a magnificent spiritual and cultural hub— Sri Radha Krishna Temple and centre for culture and education in Mangalore, Karnataka. This project, envisioned as the Grandest temple in Coastal Karnataka, will serve as a beacon of spiritual learning and community. Through this crowdfunding campaign, we aim to raise INR 22 Crores to complete Phase 1 of the construction.",
  night_view,
  background1:
    "Architect’s rendition of the stunning temple illuminated at night.",
  vision:
    "ISKCON (International Society for Krishna Consciousness), founded by A.C. Bhaktivedanta Swami Prabhupada, promotes spiritual growth and a life of unconditional love. This temple and cultural center will further fuels ISKCON’s mission to educate and uplift people of all backgrounds through spiritual practices and cultural activities.",
  temple_complex:
    "The Sri Radha Krishna Temple and Cultural center, strategically located on a hillock called Govardhana Hills, Benjanapadavu, will span 11 acres. The center will house the main Radha Krishna Temple, a multi purpose cultural theatre, value education classrooms, a Gaushala, guesthouses, a marriage hall, yoga center, wellness center cottages and much more. It will become a major spiritual and cultural destination for the region.",
  side_view,
  impact: "This center will be a hub for spiritual education and will provide an immersive cultural experience. It will feature traditional rituals, festivals, multimedia performances, and educational programs designed to deepen the connection to inner values. The temple will also provide nourishment through prasadam (sanctified food), creating a nurturing environment for visitors.",
  impact_img,
  procession,
  need: "The total estimated cost of Phase 1 is INR 25 Crores. With INR 3 Crores already raised, we need an additional INR 22 Crores to complete this phase. Construction is going to start from November 8, 2025 onwards",
  cost_breakup,
  your_contrinution: "Every contribution, no matter the size, will help bring this vision to life. Donations are eligible for tax benefits under Section 80G of the Income Tax Act. We will recognise major donors on the Wall of Gratitude.",
  join_us: "Join us in creating a temple that will serve as a beacon of spirituality and culture for millions. Together, we can make this dream a reality.",
  wall_of_gratitude,
  ongoing: "With your support, the new temple will further enhance this space, drawing millions of pilgrims and devotees annually.",
  update1,
  update2,
  update3,
  update4,
  update5,
  update6,



  image3Matter:
    "Picture : Architect’s rendition of how this magnificent temple will look at night. In the foreground is the Sri Srinivasa temple and at the back of the hillock is perched the Sri Radha Krishna temple.",
  image4Para1:
    "The construction cost for the overall center is estimated at INR 67.5 Crore. In the first phase of construction, a cost of INR 19.77 Crores has been budgeted. Approximately INR 10.4 Crore has already been raised and paid to suppliers as advance to get work started (Read the full story for all the details).",
  image4Heading:
    "There is a need to raise another INR 9.37 Crores to complete the 1st phase.",
  image4para2:
    "Through this crowdfunding campaign, I and other like-minded well-wishers are coming together to raise as much as possible to get to the INR 9.37 Crore requirement. Work has already started and the first phase is expected to be completed by AUGUST 2024.",

  image5Para:
    "There already exists a make-shift temple of Sri Krishna Balaram at this location. This is already a major spiritual destination in the twin cities.Once the new temple complex comes up it will attract many more visitors. This demonstrates the significant impact and popularity of the temple as a cultural and religious destination.",
  initiative:
    "This crowdfunding campaign of mine is to help raise funds to complete the construction of Phase 1 of the temple. What we do today will have an impact on crores of visitors and devotees for decades to come. Funding has 80G tax benefits and large funders will be recognized on the wall of gratitude ( see details below in the story).",
  initiative1:
    "The primary objective of the temple complex is to provide education and guidance on spiritual life to people of all backgrounds, races, and ethnicities. It aims to promote understanding and practice of spiritual principles, fostering a deeper connection to inner values and a more meaningful way of living.",
  initiativeBold:
    "The Sri Radha Krishna Temple and Cultural Complex, Hubli-Dharwad is not envisaged just as a building - it aims to tell a story that combines history, art, and the feeling of being connected to something greater. ",

  image6para1:
    "ACTUAL SITE PICTURE: Aerial View of the ISKCON Sri Radha Krishna Temple & Cultural Complex which is coming up at Hubli-Dharwad in Karnataka. This is strategically located on the Pune - Bengaluru highway (NH-4 ). You can see the work-in-progress at the site. The building at the bottom right of the image is the existing makeshift temple.",
  templeComplex: "WHAT IS UNIQUE ABOUT THIS TEMPLE COMPLEX?",
  templeComplexMatter:
    "The Sri Radha Krishna Temple and Cultural Complex, Hubli-Dharwad will feature traditional rituals, and festivals, and provide spiritual and value education through various events. Additionally, it will serve as a platform for students to learn, will serve food to thousands of people, will have a multimedia theatre for cultural performances, a heritage auditorium, a library, a marriage hall, a ghosala, guest houses, a restaurant, etc.",
  image7: "https://www.fueladream.com/public/uploads/2299063830847716.1%20(1)",

  image8Heading:
    "Picture: A rendition of how the temple will look in the night.",
  image8Para:
    "This campaign aims to raise funds to build this temple complex. There is no amount that is too small and no amount that is too large. Read this story to learn more about the complex. As we said we estimate it will benefit 200 Lakh (20 million) visitors over a 10-year period. Your support will help us build this brick-by-brick.",
  radhaKrishnaHeading:
    "The pictures below show the 4 main deities of the Sri Radha Krishna Temple.",
  radhaKrishnaImage:
    image9,
  image9,
  image9Para:
    "The picture above shows the Sri Srinivasa Govinda - A separate hall that would be build for Lord Venkateshwara.",
  image10,
  image10Para:
    "Sri Radha Krishna Temple & Cultural Complex in Hubli-Dharwad is dedicated to ensuring a peaceful and enriching experience for all pilgrims. The temple's commitment is to provide a serene and spiritually uplifting environment where pilgrims can connect with their beliefs and find solace. Through its services, facilities, and serene atmosphere, the temple aims to enhance the pilgrimage experience, allowing visitors to immerse themselves in their spiritual journey and find tranquillity amidst the bustling world.",
  projectStatus: image12,
  projectMatter:
    "The above picture shows the construction status and images of the ISKCON Sri Radha Krishna Temple and Cultural Complex (Phase -1) which is coming up at Hubli-Dharwad in Karnataka. ",
  projectMatter1:
    "The construction of the first phase has begun, and people are already hard at work, pouring their hearts, minds, and talent into creating this wonderful temple. The temple will shine as a symbol of hope and will bring people together. It will encourage spiritual development and harmony in the community.",
  image11: image13,
  gratitude:
    "For those of you who can and want to fund large amounts, we would like to acknowledge the same by showcasing your name ( or the name of any relative or friend of yours) on the WALL OF GRATITUDE. ",
  image12: image14,
  iskconIcon: image15,
  iskconIcon2: image16,
  image13: image17,
  image14: image18,
  taxBenfits: image19,
};

export const BE_API_URL = 'https://razor.vedicsciencecenter-clt.workers.dev'

export const donorTitles = [
  "Seva Shiromani",
  "Seva Vibhushan",
  "Seva Bhushan",
  "Maha Sevak",
  "Vishesha Sevak"
];
